import React from 'react';

import TEXT from '../../../../../data/text.json';

import FormController from '../../form-components/form-controller';
import OverlayWrapper from '../../form-components/overlay-wrapper';
import FormWrapper from '../../form-components/form-wrapper';

import { validateEmail } from '../../formValidator';

import NewItemFormStageOne from './stage-1';
import NewItemFormStageTwo from './stage-2';
import NewItemFormStageThree from './stage-3';
import NewItemFormStageFour from './stage-4';
import NewItemFormStageFive from './stage-5';

const formStages = {
  1: NewItemFormStageOne,
  2: NewItemFormStageTwo,
  3: NewItemFormStageThree,
  4: NewItemFormStageFour,
  5: NewItemFormStageFive,
};

export default class NewItemForm extends FormController {
  constructor(props) {
    super(
      props,
      [
        // Stage One
        'itemNameValue',
        'itemTypeValue',
        'itemDescValue',
        'emailValue',

        // Stage Two
        'locationValue',
        'yearValue',
        'designerValue',
        'productionMethodValue',
        'productionLocationValue',

        'tablewareTypeValue',
        'patternNumberValue',
        'colorValue',

        // Stage Three
        'mainImageValue',
        'images',

        // Stage Four
        'relatedItems',
      ],
      null,
      5,
    );

    Object.assign(this.state, {
      stage: this.state.stage || 1,
    });
  }

  handleSetImages = (images, removedMain, removedIndex) => {
    if (removedMain) {
      // If the user just removed the image with was selected as "Main" then set
      // the first image as Main if the item currently has no images
      this.setMainImageValue({ target: { value: 0 } });
    } else {
      // If the user just added the first image and the item currently has no
      // images then make the first image the "Main"
      if (this.state.images.length === 0 && images.length === 1) {
        this.setMainImageValue({ target: { value: 0 } });
      } else {
        // If the index of the removed image was less than the index of the selected
        // main then we need to decrement the main index value
        if (removedIndex < this.state.mainImageValue) {
          this.setMainImageValue({
            target: { value: this.state.mainImageValue - 1 },
          });
        }
      }
    }
    // Pass up to the actual setImages function
    this.setImages(images);
  };

  newFormValid = () => {
    const fields = this.extractFields();

    // Check that at least required fields are input
    return (
      !!fields.email &&
      validateEmail(fields.email) &&
      fields.itemName !== '' &&
      fields.itemType !== ''
    );
  };

  newFormValidationMessage = () => {
    const fields = this.extractFields();

    if (!fields.email) {
      return 'Please enter your email address';
    } else if (!validateEmail(fields.email)) {
      return TEXT.FORMS.invalidEmailAddress;
    } else if (!this.newFormValid()) {
      return 'Please provide at least the items name and type';
    }
  };

  render() {
    return (
      <OverlayWrapper
        title={TEXT.CONTRIBUTION_FORMS.NEW_ITEM.title}
        subTitle={TEXT.CONTRIBUTION_FORMS.NEW_ITEM.subTitle}
        footerProps={this.getFooterProps(
          null,
          !this.newFormValid(),
          this.newFormValidationMessage(),
        )}
        stages={[
          {
            name: 'Description',
            active: this.state.stage === 1,
            onClick: () => this.setState({ stage: 1 }),
          },
          {
            name: 'Details',
            active: this.state.stage === 2,
            onClick: () => this.setState({ stage: 2 }),
          },
          {
            name: 'Images',
            active: this.state.stage === 3,
            onClick: () => this.setState({ stage: 3 }),
          },
          {
            name: 'Related',
            active: this.state.stage === 4,
            onClick: () => this.setState({ stage: 4 }),
          },
          {
            name: 'Finish',
            active: this.state.stage === 5,
            onClick: () => this.setState({ stage: 5 }),
          },
        ]}
      >
        <FormWrapper nested>
          {React.createElement(formStages[this.state.stage], {
            // Stage One values
            itemNameValue: this.state.itemNameValue,
            setItemNameValue: this.setItemNameValue,
            itemTypeValue: this.state.itemTypeValue,
            setItemTypeValue: this.setItemTypeValue,
            itemDescValue: this.state.itemDescValue,
            setItemDescValue: this.setItemDescValue,

            // Stage Two values
            locationValue: this.state.locationValue,
            setLocationValue: this.setLocationValue,
            yearValue: this.state.yearValue,
            setYearValue: this.setYearValue,
            productionMethodValue: this.state.productionMethodValue,
            setProductionMethodValue: this.setProductionMethodValue,
            productionLocationValue: this.state.productionLocationValue,
            setProductionLocationValue: this.setProductionLocationValue,
            tablewareTypeValue: this.state.tablewareTypeValue,
            setTablewareTypeValue: this.setTablewareTypeValue,
            patternNumberValue: this.state.patternNumberValue,
            setPatternNumberValue: this.setPatternNumberValue,
            colorValue: this.state.colorValue,
            setColorValue: this.setColorValue,
            designerValue: this.state.designerValue,
            setDesignerValue: this.setDesignerValue,

            // Stage Three values
            images: this.state.images,
            setImages: this.handleSetImages,
            mainImageValue: this.state.mainImageValue,
            setMainImageValue: this.setMainImageValue,

            // Stage Four values
            relatedItems: this.state.relatedItems,
            setRelatedItems: this.setRelatedItems,

            // Stage Five
            emailValue: this.state.emailValue,
            setEmailValue: this.setEmailValue,
            formValid: this.newFormValid(),
            validationMessage: this.newFormValidationMessage(),
          })}
        </FormWrapper>
      </OverlayWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/new-item-form/index.js